import {
  SlSkeleton
} from "./chunk.SQHRCLLT.js";

// src/components/skeleton/skeleton.ts
var skeleton_default = SlSkeleton;
SlSkeleton.define("sl-skeleton");

export {
  skeleton_default
};
